// Module
var code = `<div class="external-events-btn-holder"></div>
<div class="details-example-holder"></div>
`;
// Exports
module.exports = code;